const apiUrl = process.env.NEXT_PUBLIC_API_URL;
const apiToken = process.env.API_TOKEN;
const calendlyUrl = process.env.NEXT_PUBLIC_CALENDLY_URL;

const constants = {
  shared: {
    apiUrl,
    calendlyUrl,
  },

  /**
   *
   * these constants are not accessible on the client-side
   * and shouldn't be changed to public for security
   *
   */
  server: {
    apiToken,
  },
};

export default constants;
